import { makeStyles } from 'tss-react/mui';
import { P2GBox, P2GGrid, P2GIcon, P2GText, SvgLiveHelp } from '@parcel2go/core-ui';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import { ChatBase } from '@parcel2go/npm-p2g-app';

type LiveChatVariant = 'BASKET' | 'SIDEBAR';
type props = { variant: LiveChatVariant };

const useStyles = (v: LiveChatVariant) =>
  makeStyles()((theme) => ({
    liveChat: {
      display: v === 'SIDEBAR' ? 'display' : 'flex',
      cursor: 'pointer',
      [theme.breakpoints.only('xs')]: {
        display: 'block'
      },
      '& > div': {
        textAlign: 'center',
        display: 'inline-block'
      }
    },
    container: {
      padding: theme.spacing(2, 6, 2, 2),
      [theme.breakpoints.only('xs')]: {
        padding: theme.spacing(2)
      },
      borderRadius: theme.shape.borderRadius * 3,
      backgroundColor: 'white',
      margin: 0,
      border: `1px solid ${theme.palette.grey[200]}`
    }
  }));

const LiveChat = ({ variant }: props) => {
  const { classes } = useStyles(variant)();
  const { t } = useTranslation([TranslationNamespaces.CHECKOUT]);

  return (
    <P2GBox classNames={classes.liveChat}>
      <ChatBase>
        <P2GBox classNames={classes.container}>
          <P2GGrid container wrap="nowrap" direction="row" gap={2} justify="center">
            <P2GGrid item>
              <P2GIcon size="lg" palette="primary">
                <SvgLiveHelp />
              </P2GIcon>
            </P2GGrid>
            <P2GGrid item>
              <P2GGrid container direction="column" gap={1}>
                <P2GGrid item>
                  <P2GText variant="h3">{t('LIVE_CHAT_BUTTON_TITLE', { defaultValue: 'Live Help' })}</P2GText>
                </P2GGrid>
                <P2GGrid item>
                  <P2GText variant="body1">
                    {t('LIVE_CHAT_BUTTON_MESSAGE', { defaultValue: 'Talk to an Operator' })}
                  </P2GText>
                </P2GGrid>
              </P2GGrid>
            </P2GGrid>
          </P2GGrid>
        </P2GBox>
      </ChatBase>
    </P2GBox>
  );
};
export default LiveChat;
